import React, {useState, useRef, useEffect} from "react";
import {useDispatch} from "react-redux";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import {
  CUSTOMER_ID_SESSION_KEY,
  ADOBEDTM_PAGE_NAME,
  getIDToSet,
} from "../../constants";
import {
  removeEverySpace,
  parseFormInput,
  validateIdSpecificPattern,
} from "../../services/Validator";
import {
  // dataDashboard,
  checkContentAvlInArray,
} from "../../util";
import {idFormatMap, getFormattedIdForGivenInput} from "../../util/common";
import {setCustomerDetails, setInputUserID} from "../../actions/customer";
import {useTranslation} from "react-i18next";
import useForm from "../../hooks/useForm";
import FormPanel from "../../components/FormPanel";
import Dropdown from "../../components/Dropdown/Dropdown";
import Button from "../../components/Button";
import {useNavigate} from "react-router-dom";
import "./idInputField.scss";

import config from "../../../config";
const formattedIDVerificationList = [
  "validateCPF",
  "validateCI",
  "validateRUT",
  "validateARDNI",
];
const idFormattedCountryList = ["CL", "BR", "UY", "AR"];

const IdInputField = ({isWelcomePage, getIsSubmitButtonDisabledAndInput}) => {
  const {t} = useTranslation();
  const loginFormModel = [];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const customerSlotDetails = getCustomerSlotDetails();
  const idConfig = useRef(config.id_alternatives[customerSlotDetails?.country]);
  const idTypes = useRef(config.id_alternatives[customerSlotDetails?.country]);
  const stdCode = useRef(config.phone_code_map[customerSlotDetails?.country]);

  const [docType, setDocType] = useState(
    idConfig.current[idConfig.current?.findIndex((val) => val.default === true)]
  );
  const multiIdDisabled = config.multi_id_disabled_bu_list.includes(
    customerSlotDetails.bu
  );
  const [docTypeLength, setDocTypeLength] = useState(
    idConfig.current[idConfig.current?.findIndex((val) => val.default === true)]
      .length
  );
  const [docTypeValidation, setDocTypeValidation] = useState(
    idConfig.current[idConfig.current?.findIndex((val) => val.default === true)]
      .validationType
  );
  const [idSpecificValidation, setIdSpecificValidation] = useState(
    idConfig.current[idConfig.current?.findIndex((val) => val.default === true)]
      .specificValidation
  );
  const [labelName, setLabelName] = useState(
    idConfig.current[idConfig.current?.findIndex((val) => val.default === true)]
      .label
  );
  const [inpData, setInpData] = useState([]);
  const formatId = useRef(true);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const customerDetails = getCustomerSlotDetails() || null;
    dispatch(setCustomerDetails(customerDetails || null));
    // let timer = setTimeout(() => {
    //   // for data dashboard
    //   const URL = window.location.href.split("/")[2];
    //   const officeApp = customerSlotDetails.isOffice
    //     ? URL + "/office"
    //     : URL + "/app";
    //   const datamap = new Map();
    //   datamap.set("pageName", ADOBEDTM_PAGE_NAME.Home_Page);
    //   datamap.set("prop1", URL);
    //   datamap.set("prop2", officeApp);
    //   dataDashboard(datamap);
    //   return () => {
    //     clearTimeout(timer);
    //   };
    // }, 1000);
    return () => {
      resetData();
    };
  }, []);
  const formatUserId = (temp) => {
    let pattern;
    let formattedId;
    if (
      temp?.length <= docType?.max &&
      temp?.length > 0 &&
      formatId.current !== false
    ) {
      if (
        idFormatMap[docType?.docType] &&
        idFormatMap[docType?.docType].constructor == Object
      ) {
        pattern = idFormatMap[docType?.docType][temp.length]
          ? idFormatMap[docType?.docType][temp.length]
          : idFormatMap[docType?.docType][docType?.docType];
        formattedId = getFormattedIdForGivenInput(temp, pattern, formatId);
        setInpData([...inpData, (inpData[0].value = formattedId)]);
      } else {
        if (idFormatMap[docType?.docType]) {
          pattern = idFormatMap[docType?.docType];
          formattedId = getFormattedIdForGivenInput(temp, pattern, formatId);
          setInpData([...inpData, (inpData[0].value = formattedId)]);
        }
      }
    }
  };
  useEffect(() => {
    if (idFormattedCountryList.includes(customerSlotDetails?.country)) {
      const inputData = inpData[0]?.value;
      const temp = inputData?.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "");
      formatUserId(temp);
    }
    if (formattedIDVerificationList?.includes(idSpecificValidation)) {
      handleFormattedIDValidation();
    } else {
      if (inpData?.length > 0 && inpData[0]?.value) {
        if (!"alert" in inpData[0]) {
          setIsSubmitDisabled(false);
        } else if ("alert" in inpData[0]) {
          if (inpData[0]?.alert === null) {
            setIsSubmitDisabled(false);
          } else {
            setIsSubmitDisabled(true);
          }
        }
      } else {
        setIsSubmitDisabled(true);
      }
    }
  }, [inpData]);

  useEffect(() => {
    if (getIsSubmitButtonDisabledAndInput) {
      getIsSubmitButtonDisabledAndInput({
        isSubmitDisabled,
        inputValue: inpData[0]?.value,
      });
    }
  }, [isSubmitDisabled]);

  const handleFormattedIDValidation = () => {
    if (inpData[0] && inpData[0]?.value) {
      const isValid = validateFormattedInput(inpData[0]?.value);
      if (isValid) {
        setIsSubmitDisabled(false);
      } else {
        setIsSubmitDisabled(true);
      }
    }
  };

  const selectProcess = (id) => {
    const selectedVal = id.value;
    setDocType(id);
    setDocTypeLength(
      idConfig.current[
        idConfig.current.findIndex((val) => val.value === selectedVal)
      ].length
    );
    setDocTypeValidation(
      idConfig.current[
        idConfig.current.findIndex((val) => val.value === selectedVal)
      ].validationType
    );
    setIdSpecificValidation(
      idConfig.current[
        idConfig.current.findIndex((val) => val.value === selectedVal)
      ].specificValidation
    );
    setLabelName(
      idConfig.current[
        idConfig.current.findIndex((val) => val.value === selectedVal)
      ].label
    );
  };

  const prepareLoginFormModel = () => {
    loginFormModel?.push({
      name: "common-text",
      parser: removeEverySpace,
      type: "text",
      defaultInput:
        customerSlotDetails?.country === "MX" ? "+" + stdCode?.current : "",
      value: customerSlotDetails[CUSTOMER_ID_SESSION_KEY]
        ? customerSlotDetails[CUSTOMER_ID_SESSION_KEY]
        : "",
      validators: [
        {
          id: "id-pattern",
          isValid: validateIdSpecificPattern,
          alert:
            idTypes?.current.length !== 1
              ? t("enterRightID")
              : isWelcomePage
              ? "*" + t("pleaseEnter") + " " + labelName + " " + t("valid")
              : t("customerInfoPage.input.error"),
        },
      ],
    });
  };

  prepareLoginFormModel();
  const submitCallback = (e) => {
    let sessionData = {};
    loginFormModel?.forEach((m) => {
      if (m.name === "common-text") {
        const ID = getIDToSet(customerSlotDetails?.country);
        sessionData[ID] =
          idSpecificValidation !== "validateEmail"
            ? parseFormInput.parseOnlyLetterAndNumbers(
                e[
                  e.findIndex((val) => val.name === "common-text")
                ].value.toLowerCase()
              )
            : e[
                e.findIndex((val) => val.name === "common-text")
              ].value.toLowerCase();
      }
      sessionData["userIdType"] = docType.value;
      setCustomerSlotDetails({...customerSlotDetails, ...sessionData});
      // const datamap = new Map();
      // datamap.set("events", "event14=1");
      // datamap.set("eVar6", labelName);
      // // datamap.set("eVar7", sessionData.userId); This line will be uncommented after the hashing is confirmed
      // dataDashboard(datamap);
      return;
    });
    isWelcomePage && proceedServiceSelectionPage();
  };

  const proceedServiceSelectionPage = () => {
    const data = getCustomerSlotDetails();
    if (config.turnero_enabled_bu_list.includes(data.bu)) {
      navigate("/customer/selectTurneroStoreAndType");
    } else {
      if (
        checkContentAvlInArray(
          config.stand_alone_bu_list,
          customerSlotDetails.buList
        )
      ) {
        navigate("/customer/selectMallStore");
      } else {
        navigate("/customer/selectStore");
      }
    }
  };

  const [inputs, setInputs, setSubmit, validateFormattedInput] = useForm(
    formattedIDVerificationList,
    loginFormModel,
    submitCallback,
    docTypeLength,
    docTypeValidation,
    idSpecificValidation
  );

  const getInputData = (data) => {
    if (data && data.length) {
      if (idFormattedCountryList?.includes(customerSlotDetails?.country)) {
        formatId.current = true;
      }
      dispatch(setInputUserID(data[0]?.value));
      setInpData(data);
    }
  };

  const resetData = () => {
    if (inpData?.length !== 0) {
      const temp = inpData;
      temp.map((item) => {
        item.value = "";
      });
      setInpData(temp);
    }
  };

  return (
    <div className="guestPage-form">
      {multiIdDisabled || idTypes.current.length === 1 ? (
        ""
      ) : (
        <div className="guestLogin-label-dropdown">
          <section className="guestlogin-options-section">
            <label className="custom-label">
              {isWelcomePage
                ? t("selectDocument")
                : t("customerInfoPage.selectDocument").toUpperCase()}
            </label>
          </section>
          <Dropdown
            options={idTypes.current}
            onChange={(data) => selectProcess(data.option)}
            value={docType ? docType : null}
            isSearchable="false"
          />
        </div>
      )}
      <div className={`guestLogin-label-inp success-${!isSubmitDisabled}`}>
        <section className="guestlogin-options-section">
          {isWelcomePage === true ? (
            <label htmlFor="options" className="custom-label">
              {t("enterId.label1")} {labelName} {t("enterId.label2")}
            </label>
          ) : (
            <label htmlFor="options" className="custom-label">
              {idTypes.current.length > 1
                ? t("customerInfoPage.idDorpdownLabel")
                : labelName}
            </label>
          )}
        </section>
        <FormPanel
          id="control-trafico-login-form-guest"
          placeholder={
            isWelcomePage === true
              ? t("guestLandingPage.input.placeholder")
              : t("customerInfoPage.input.id.placeholder1") +
                " " +
                docType?.docType +
                " " +
                t("customerInfoPage.input.id.placeholder2")
          }
          submitCallback={submitCallback}
          model={loginFormModel}
          validateLength={docTypeLength}
          validatePattern={docTypeValidation}
          countryAndIdTypeValidationPattern={idSpecificValidation}
          getInputData={(data) => {
            getInputData(data);
          }}
          formattedIDVerificationList={formattedIDVerificationList}
          isSuccess={!isSubmitDisabled}
          isWelcomePage={isWelcomePage}
        />
      </div>
      {isWelcomePage && (
        <Button
          formId="control-trafico-login-form-guest"
          disabled={isSubmitDisabled}
          newDesign={true}
          customClass="spaceAround"
          value={t("inStoreFeature")}
        />
      )}
    </div>
  );
};

export default IdInputField;
